import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const CTASection = () => {
  const { language, t } = useLanguage();

  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-purple-700 to-purple-900" />
      
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-orange-400/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-400/20 rounded-full blur-3xl" />

      <div className="relative max-w-4xl mx-auto px-4 text-center">
        <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white px-4 py-2 rounded-full text-sm mb-6 border border-white/20">
          <Sparkles size={16} className="text-orange-400" />
          {language === 'sv' ? 'Låt oss hjälpa dig' : 'Let us help you'}
        </div>

        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
          {language === 'sv' 
            ? 'Redo för ett skinande rent hem?' 
            : 'Ready for a sparkling clean home?'
          }
        </h2>

        <p className="text-xl text-purple-100 mb-10 max-w-2xl mx-auto">
          {language === 'sv'
            ? 'Få en kostnadsfri offert idag. Vi tar hand om städningen så att du kan fokusera på det som är viktigt.'
            : 'Get a free quote today. We handle the cleaning so you can focus on what matters.'
          }
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <a href="/#calculator">
            <Button className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-6 text-lg font-semibold shadow-xl shadow-orange-500/30 hover:shadow-orange-500/50 transition-all hover:scale-105">
              {t.hero.cta}
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </a>
          <Link to="/contact">
            <Button variant="outline" className="border-2 border-white/30 text-white hover:bg-white/10 px-8 py-6 text-lg font-semibold">
              {t.hero.secondaryCta}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
